export type About = {
  isModalOpen: boolean;
};

export function getInitialAboutState() {
  return { isModalOpen: false };
}
